import React from 'react'
import { SaveButton, Toolbar } from 'react-admin'

// interface ToolbarProps {
//   setOpenLesson: () => void
//   setOpenWeek: () => void
// }

export const CreateToolbar = (props: any) => {
  const { closeDrawer } = props
  return (
    <Toolbar {...props}>
      <SaveButton label="SALVAR" submitOnEnter={true} />
      {closeDrawer}
    </Toolbar>
  )
}
